import { render } from "./PasswordWithBadgeInput.vue?vue&type=template&id=453bfff4"
import script from "./PasswordWithBadgeInput.vue?vue&type=script&lang=js"
export * from "./PasswordWithBadgeInput.vue?vue&type=script&lang=js"

import "./PasswordWithBadgeInput.vue?vue&type=style&index=0&id=453bfff4&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__